import { render, staticRenderFns } from "./NotPaidStudentsCoursePage.vue?vue&type=template&id=3513f2f5&scoped=true&"
import script from "./NotPaidStudentsCoursePage.vue?vue&type=script&lang=js&"
export * from "./NotPaidStudentsCoursePage.vue?vue&type=script&lang=js&"
import style0 from "./NotPaidStudentsCoursePage.vue?vue&type=style&index=0&id=3513f2f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513f2f5",
  null
  
)

export default component.exports